export default __webpack_public_path__ + "static/media/RogerLim.9ccc09dc.png";